import script from "./MenuSuperiorDashAgro.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuSuperiorDashAgro.vue?vue&type=script&setup=true&lang=js"

import "./MenuSuperiorDashAgro.vue?vue&type=style&index=0&id=246eb278&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-246eb278"]])

export default __exports__